<template>
  <div class="client-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="row">
            <div class="col-sm-10 col-form-label uppercase">
              <strong class="first"><h3>{{$t('client.clients')}}</h3></strong>
            </div>

            <legend class="col-sm-2 col-form-label text-right">
              <span style="margin-right: 15px;">
                {{$t('client.active')}}
              </span>
              <c-switch style="margin-top: 0" class="active" type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.status" :value="1" :uncheckedValue="0" />
            </legend>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card class="header mb-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('common.basic_information') }}</strong>
            </div>
            <b-form v-if="item != null">
              <b-row>
                <b-col cols="12">
                  <b-form-group v-bind:label="$t('client.name')" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.name" />
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.country')" :label-cols="2" :horizontal="true">
                    <b-form-select class="form-control border-radius-4px" v-model="item.country" :options="countries"/>
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.contact_name')" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.contact_name" />
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.base_site_url')" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.base_site_url" />
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.logo')" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.gms_config.base.logo" />
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="b-form-group form-group">
                  <div class="form-row">
                    <b-col cols="2">
                      <legend class="col-form-label">{{$t('client.phone')}}</legend>
                    </b-col>
                    <b-col cols="4">
                      <b-form-input class="form-control border-radius-4px" v-model="item.phone" />
                    </b-col>
                    <b-col cols="2">
                      <legend class="col-form-label">{{$t('client.email')}}</legend>
                    </b-col>
                    <b-col cols="4">
                      <b-form-input class="form-control border-radius-4px" v-model="item.email" />
                    </b-col>
                  </div>
                </b-col>
                <b-col cols="12">
                  <b-form-group v-bind:label="$t('client.languages')" :label-cols="2" :horizontal="true">
                    <multiselect class="border-radius-4px" v-model="selected_languages" label="text" :close-on-select="false" track-by="value" :options="languages" :multiple="true" >
                    </multiselect>
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.main_language')" :label-cols="2" :horizontal="true">
                    <b-form-select class="form-control border-radius-4px" v-model="item.main_config.main_language" :options="selected_languages"/>
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.tax')" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.tax" />
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.point_rate')" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.point_rate" />
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.currency')" :label-cols="2" :horizontal="true">
                    <multiselect class="border-radius-4px" v-model="selected_currency" label="name" track-by="code" :options="currencies">
                    </multiselect>
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.currency_info')" :label-cols="2" :horizontal="true">
                    <div class="currency-info">
                      <b-row>
                        <b-col cols="6" v-for="(info, key) in selected_currency" :key="info.code">
                          <b-form-group v-bind:label="$t('client.' + key)" :label-cols="4" :horizontal="true">
                            <b-form-input class="form-control border-radius-4px" :value="info" readonly/>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </div>
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.tiers')" :label-cols="2" :horizontal="true">
                    <table class="table table-striped">
                      <thead>
                      <tr>
                        <th>{{$t('client.key')}}</th>
                        <th>{{$t('client.name')}}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(t, index) in tier">
                        <td>
                          <legend class="col-form-label">{{t.value}}</legend>
                        </td>
                        <td>
                          <b-form-input class="form-control border-radius-4px" v-model="tier[index].text"/>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <button type="button" class="btn bg-main border-radius-4px" @click="addTier"><i class="fa fa-plus"></i> {{$t('common.add')}}</button>
                          <button type="button" class="btn btn-danger border-radius-4px pull-right" @click="removeTier"><i class="fa fa-trash-o"></i> {{$t('common.remove')}}</button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.allowed_order_value')" :label-cols="2" :horizontal="true">
                    <table class="table table-striped">
                      <tr>
                        <td>
                          <b-form-group v-bind:label="$t('client.max_cash_value')" :label-cols="3" :horizontal="true">
                           <b-form-input class="form-control border-radius-4px" v-model="item.main_config.max_cash_value"/>
                          </b-form-group>
                        </td>
                        <td>
                          <b-form-group v-bind:label="$t('client.max_noncash_value')" :label-cols="3" :horizontal="true">
                            <b-form-input class="form-control border-radius-4px" v-model="item.main_config.max_noncash_value"/>
                          </b-form-group>
                        </td>
                      </tr>
                    </table>
                  </b-form-group>
                  <b-form-group label="Send Email to Customer" :label-cols="2" :horizontal="true">
                    <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.main_config.email_flag" :value="1" :uncheckedValue="0"/>
                  </b-form-group>
                  <b-form-group label="Send SMS to Customer" :label-cols="2" :horizontal="true">
                    <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.main_config.sms_flag" :value="1" :uncheckedValue="0"/>
                  </b-form-group>
                  <b-form-group label="Tax Type" :label-cols="2" :horizontal="true">
                    <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.main_config.tax_flag" :value="1" :uncheckedValue="0"/>
                  </b-form-group>
                  <b-form-group label="Discount Type" :label-cols="2" :horizontal="true">
                    <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.main_config.discount_apply_flag" :value="1" :uncheckedValue="0"/>
                  </b-form-group>
                  <b-form-group label="Christmas Theme" :label-cols="2" :horizontal="true">
                    <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.main_config.christmas_theme" :value="1" :uncheckedValue="0"/>
                  </b-form-group>
                  <b-form-group label="Order Status Mapping" :label-cols="2" :horizontal="true">
                    <table class="table table-striped">
                      <thead>
                      <tr>
                        <th>Order Status</th>
                        <th>Order Step</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(step, status) in item.main_config.order_status_mappings">
                        <td>
                          {{order_status[status]}} (Code: {{status}})
                        </td>
                        <td>
                          <b-form-select class="form-control border-radius-4px" v-model="item.main_config.order_status_mappings[status]" :options="order_step"/>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </b-form-group>
                  <b-form-group label="Aggregators" :label-cols="2" :horizontal="true">
                    <table class="table table-striped">
                      <thead>
                      <tr>
                        <th>Name</th>
                        <th>Active</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(step, status) in item.gms_config.base.aggregators">
                        <td>
                          {{aggregators[status]}} (Code: {{status}})
                        </td>
                        <td>
                          <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.gms_config.base.aggregators[status]" :value="1" :uncheckedValue="0"/>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </b-form-group>
                  <b-form-group label="Total Discount" :label-cols="2" :horizontal="true">
                    <b-form-select class="form-control border-radius-4px" v-model="item.main_config.total_discount" :options="[
                    {text: 'Round Down', value: -1},
                    {text: 'Round', value: 0},
                    {text: 'Round Up', value: 1}
                    ]"/>
                  </b-form-group>
                  <b-form-group label="Tax Total" :label-cols="2" :horizontal="true">
                    <b-form-select class="form-control border-radius-4px" v-model="item.main_config.tax_total" :options="[
                    {text: 'Round Down', value: -1},
                    {text: 'Round', value: 0},
                    {text: 'Round Up', value: 1}
                    ]"/>
                  </b-form-group>
                  <b-form-group label="Total" :label-cols="2" :horizontal="true">
                    <b-form-select class="form-control border-radius-4px" v-model="item.main_config.total" :options="[
                    {text: 'Round Down', value: -1},
                    {text: 'Round', value: 0},
                    {text: 'Round Up', value: 1}
                    ]"/>
                  </b-form-group>
                  <b-form-group label="Money for Point" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.money_for_point"/>
                  </b-form-group>
                  <b-form-group label="Date Format" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.date_format"/>
                  </b-form-group>
                  <b-form-group label="Min Cart include Delivery Fee" :label-cols="2" :horizontal="true">
                    <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.main_config.min_cart_include_delivery_fee" :value="1" :uncheckedValue="0"/>
                  </b-form-group>


                  <b-form-group label="FCDS App" :label-cols="2" :horizontal="true">
                    <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.main_config.fcds_app" :value="1" :uncheckedValue="0"/>
                  </b-form-group>
                  <b-form-group label="Calendar Notification" :label-cols="2" :horizontal="true">
                    <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.main_config.calendar_notification" :value="1" :uncheckedValue="0"/>
                  </b-form-group>

                  <b-form-group label="IOS Min Version" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.ios_min_version"/>
                  </b-form-group>
                  <b-form-group label="Android Min Version" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.android_min_version" />
                  </b-form-group>

                  <b-form-group label="Web Maintenance" :label-cols="2" :horizontal="true">
                    <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.main_config.web_maintenance" :value="1" :uncheckedValue="0"/>
                  </b-form-group>
                  <b-form-group label="IOS Maintenance" :label-cols="2" :horizontal="true">
                    <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.main_config.ios_maintenance" :value="1" :uncheckedValue="0"/>
                  </b-form-group>
                  <b-form-group label="Android Maintenance" :label-cols="2" :horizontal="true">
                    <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.main_config.android_maintenance" :value="1" :uncheckedValue="0"/>
                  </b-form-group>
                  <b-form-group label="Auto Coupon" :label-cols="2" :horizontal="true">
                    <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.main_config.auto_coupon" :value="1" :uncheckedValue="0"/>
                  </b-form-group>
                  <b-form-group label="Half Half Full Price" :label-cols="2" :horizontal="true">
                    <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.main_config.half_half_full_price" :value="1" :uncheckedValue="0"/>
                  </b-form-group>
                  <b-form-group label="Join Membership" :label-cols="2" :horizontal="true">
                    <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.main_config.join_membership" :value="1" :uncheckedValue="0"/>
                  </b-form-group>
                  <b-form-group label="Enable Blacklist Users" :label-cols="2" :horizontal="true">
                    <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.main_config.blacklist_users" :value="1" :uncheckedValue="0"/>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
            <div slot="footer">
              <div class="btn-save">
                <button type="button" class="btn bg-main border-radius-4px pl-3 pr-3" v-on:click="saveClient"> {{$t('common.save')}}</button>
              </div>
            </div>
          </b-card>

          <b-card class="mb-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('client.social') }}</strong>
            </div>
            <b-form v-if="item != null">
              <b-row>
                <b-col cols="12">
                  <b-form-group v-bind:label="$t('client.api_key')" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.backend.api_key" />
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.facebook_secret_key')" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.backend.fb.app_secret" />
                  </b-form-group>

                  <b-form-group v-bind:label="$t('client.apple_app_id')" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.backend.apple.app_id" />
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.apple_app_secret')" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.backend.apple.app_secret" />
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.apple_key_id')" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.backend.apple.key_id" />
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.apple_team_id')" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.backend.apple.team_id" />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </b-card>

          <b-card class="mb-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('client.social') }}</strong>
            </div>
            <b-form v-if="item != null">
              <b-row>
                <b-col cols="12">
                  <!-- facebook config -->
                  <b-form-group v-bind:label="$t('client.facebook_id')" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.social.fb.app_id" />
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.facebook_secret_key')" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.backend.fb.app_secret" />
                  </b-form-group>

                  <!-- google config -->
                  <b-form-group v-bind:label="$t('client.google_id') + ' (Website)'" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.social.gg.web" />
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.google_id') + ' (IOS)'" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.social.gg.ios" />
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.google_id') + ' (Android)'" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.social.gg.android" />
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.google_api_key')" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.google_api_key" />
                  </b-form-group>
                  <b-form-group v-bind:label="$t('client.private_key')" :label-cols="2" :horizontal="true">
                    <b-form-input class="form-control border-radius-4px" v-model="item.main_config.private_key" />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
          <b-card class="mb-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('client.manual') }}</strong>
            </div>
            <div class="ml-4">
              <button type="button" class="btn btn-success right" @click="createManualConfig"><i class="fa fa-plus"></i>&nbsp; {{$t('client.new_manual_config')}}</button>
            </div>
            <div class="mt-3">
              <b-form>
                <b-row v-for="(config,indexManualConfig) in manual_config" :key="indexManualConfig+0">
                  <b-col cols="5">
                    <b-form-group v-bind:label="$t('client.key')" :label-cols="2" :horizontal="true">
                      <b-form-input class="form-control border-radius-4px" v-model="manual_config[indexManualConfig]['key']"/>
                    </b-form-group>
                  </b-col>
                  <b-col cols="5">
                    <b-form-group v-bind:label="$t('client.value')" :label-cols="2" :horizontal="true">
                      <b-form-textarea v-if="manual_config[indexManualConfig]['key'] === 'unavailable_product_skus'" class="form-control border-radius-4px" v-model="manual_config[indexManualConfig]['value']" :rows="5" :max-rows="10">
                      </b-form-textarea>
                      <b-form-input v-else class="form-control border-radius-4px" v-model="manual_config[indexManualConfig]['value']"/>
                    </b-form-group>
                  </b-col>
                  <b-col cols="2">
                    <button type="button" class="btn btn-danger right" @click="deleteManualConfig(indexManualConfig)"><i class="fa fa-trash"></i>&nbsp; {{$t('client.delete_manual_config')}}</button>
                  </b-col>
                </b-row>
              </b-form>
            </div>
          </b-card>

          <b-card class="mb-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('client.config') }}</strong>
            </div>
            <b-row>
                <button type="button" class="btn bg-main border-radius-4px"  style="margin: 0 5px" v-b-modal.menu>{{$t('side_bar.menu')}}</button>
                <button type="button" class="btn bg-main border-radius-4px"  style="margin: 0 5px" v-b-modal.menu_half_half>{{$t('side_bar.menu_half_half')}}</button>
                <button type="button" class="btn bg-main border-radius-4px " style="margin: 0 5px" v-b-modal.combo>{{$t('side_bar.combo')}}</button>
                <button type="button" class="btn bg-main border-radius-4px " style="margin: 0 5px"  v-b-modal.coupon>{{$t('side_bar.coupons')}}</button>
                <button type="button" class="btn bg-main border-radius-4px " style="margin: 0 5px" v-b-modal.outlet>{{$t('side_bar.outlets')}}</button>
                <button type="button" class="btn bg-main border-radius-4px " style="margin: 0 5px"  v-b-modal.order>{{$t('side_bar.orders')}}</button>
                <button type="button" class="btn bg-main border-radius-4px " style="margin: 0 5px" v-b-modal.category>{{$t('side_bar.category')}}</button>
                <button type="button" class="btn bg-main border-radius-4px " style="margin: 0 5px" v-b-modal.banner>{{$t('side_bar.banner')}}</button>
                <button type="button" class="btn bg-main border-radius-4px " style="margin: 0 5px" v-b-modal.customer>{{$t('side_bar.customers')}}</button>
                <button type="button" class="btn bg-main border-radius-4px " style="margin: 0 5px" v-b-modal.report>{{$t('side_bar.reports')}}</button>
                <button type="button" class="btn bg-main border-radius-4px " style="margin: 0 5px" v-b-modal.user :disabled="isUserBtnDisabled" >{{$t('side_bar.out_of_stock')}}</button>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <b-modal id="outlet" :title="$t('side_bar.outlets')" size="lg">
      <outlet-form v-model="item.gms_config.outlet" :item="item"></outlet-form>
    </b-modal>
    <b-modal id="menu" :title="$t('side_bar.menu')" size="lg">
      <menu-form v-model="item.gms_config.menu"></menu-form>
    </b-modal>
    <b-modal id="combo" :title="$t('side_bar.combo')" size="lg">
      <combo-form v-model="item.gms_config.combo"></combo-form>
    </b-modal>
    <b-modal id="order" :title="$t('side_bar.order')" size="lg">
      <order-form v-model="item.gms_config.order"></order-form>
    </b-modal>
    <b-modal id="customer" :title="$t('side_bar.customers')" size="lg">
      <customer-form v-model="item.gms_config.customer"></customer-form>
    </b-modal>
    <b-modal id="coupon" :title="$t('side_bar.coupon')" size="lg">
      <coupon-form v-model="item.gms_config.coupon"></coupon-form>
    </b-modal>
    <b-modal id="report" :title="$t('side_bar.reports')" size="lg">
      <report-form v-model="item.gms_config.report"></report-form>
    </b-modal>
     <b-modal id="user" ref="user" :title="$t('side_bar.out_of_stock')" size="lg" hide-footer>
      <user-form v-model="item"></user-form>
    </b-modal>
     <b-modal id="category" ref="category" :title="$t('side_bar.category')" size="lg">
      <category-form v-model="item.gms_config.category"></category-form>
    </b-modal>
    <b-modal id="banner" ref="banner" :title="$t('side_bar.banner')" size="lg">
      <banner-form v-model="item.gms_config.banner"></banner-form>
    </b-modal>
    <b-modal id="menu_half_half" ref="menu_half_half" :title="$t('side_bar.menu_half_half')" size="lg">
      <menu-half-half-form v-model="item.gms_config.menu_half_half"></menu-half-half-form>
    </b-modal>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required, email} from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'
  import Tables from '../../tables/Tables'
  import Multiselect from 'vue-multiselect'
  import OutletForm from './OutletForm'
  import MenuForm from './MenuForm'
  import BannerForm from './BannerForm'
  import MenuHalfHalfForm from './MenuHalfHalfForm'
  import ComboForm from './ComboForm'
  import OrderForm from './OrderForm'
  import CustomerForm from './CustomerForm'
  import CouponForm from './CouponForm'
  import ReportForm from './ReportForm'
  import UserForm from './UserForm'
  import CategoryForm from './CategoryForm'
  let vm = null

  export default {
    name: 'ClientForm',
    props: {
      uuid: {
        type: String
      }
    },
    components: {
      CustomerForm,
      Tables,
      cSwitch,
      Multiselect,
      OutletForm,
      MenuForm,
      ComboForm,
      OrderForm,
      CouponForm,
      ReportForm,
      UserForm,
      CategoryForm,
      BannerForm,
      MenuHalfHalfForm
    },
    data: function () {
      return {
        test: [],
        currency: {},
        tier: [
          {
            text: '',
            value: 1
          }
        ],
        languages: [
          {
            value: 'en',
            text: 'English'
          },
          {
            value: 'ja',
            text: 'Japanese'
          },
          {
            value: 'id',
            text: 'Indonesian'
          },
          {
            value: 'ar',
            text: 'Kuwait'
          },
          {
            value: 'pt',
            text: 'Portuguese'
          },
          {
            value: 'es',
            text: 'Spanish'
          }
        ],
        selected_languages: [],
        selected_currency: [],
        countries: {
          'AF': 'Afghanistan',
          'AX': 'Åland Islands',
          'AL': 'Albania',
          'DZ': 'Algeria',
          'AS': 'American Samoa',
          'AD': 'Andorra',
          'AO': 'Angola',
          'AI': 'Anguilla',
          'AQ': 'Antarctica',
          'AG': 'Antigua and Barbuda',
          'AR': 'Argentina',
          'AM': 'Armenia',
          'AW': 'Aruba',
          'AU': 'Australia',
          'AT': 'Austria',
          'AZ': 'Azerbaijan',
          'BS': 'Bahamas',
          'BH': 'Bahrain',
          'BD': 'Bangladesh',
          'BB': 'Barbados',
          'BY': 'Belarus',
          'BE': 'Belgium',
          'BZ': 'Belize',
          'BJ': 'Benin',
          'BM': 'Bermuda',
          'BT': 'Bhutan',
          'BO': 'Bolivia, Plurinational State of',
          'BQ': 'Bonaire, Sint Eustatius and Saba',
          'BA': 'Bosnia and Herzegovina',
          'BW': 'Botswana',
          'BV': 'Bouvet Island',
          'BR': 'Brazil',
          'IO': 'British Indian Ocean Territory',
          'BN': 'Brunei Darussalam',
          'BG': 'Bulgaria',
          'BF': 'Burkina Faso',
          'BI': 'Burundi',
          'KH': 'Cambodia',
          'CM': 'Cameroon',
          'CA': 'Canada',
          'CV': 'Cape Verde',
          'KY': 'Cayman Islands',
          'CF': 'Central African Republic',
          'TD': 'Chad',
          'CL': 'Chile',
          'CN': 'China',
          'CX': 'Christmas Island',
          'CC': 'Cocos (Keeling) Islands',
          'CO': 'Colombia',
          'KM': 'Comoros',
          'CG': 'Congo',
          'CD': 'Congo, the Democratic Republic of the',
          'CK': 'Cook Islands',
          'CR': 'Costa Rica',
          'CI': 'Côte d\'Ivoire',
          'HR': 'Croatia',
          'CU': 'Cuba',
          'CW': 'Curaçao',
          'CY': 'Cyprus',
          'CZ': 'Czech Republic',
          'DK': 'Denmark',
          'DJ': 'Djibouti',
          'DM': 'Dominica',
          'DO': 'Dominican Republic',
          'EC': 'Ecuador',
          'EG': 'Egypt',
          'SV': 'El Salvador',
          'GQ': 'Equatorial Guinea',
          'ER': 'Eritrea',
          'EE': 'Estonia',
          'ET': 'Ethiopia',
          'FK': 'Falkland Islands (Malvinas)',
          'FO': 'Faroe Islands',
          'FJ': 'Fiji',
          'FI': 'Finland',
          'FR': 'France',
          'GF': 'French Guiana',
          'PF': 'French Polynesia',
          'TF': 'French Southern Territories',
          'GA': 'Gabon',
          'GM': 'Gambia',
          'GE': 'Georgia',
          'DE': 'Germany',
          'GH': 'Ghana',
          'GI': 'Gibraltar',
          'GR': 'Greece',
          'GL': 'Greenland',
          'GD': 'Grenada',
          'GP': 'Guadeloupe',
          'GU': 'Guam',
          'GT': 'Guatemala',
          'GG': 'Guernsey',
          'GN': 'Guinea',
          'GW': 'Guinea-Bissau',
          'GY': 'Guyana',
          'HT': 'Haiti',
          'HM': 'Heard Island and McDonald Islands',
          'VA': 'Holy See (Vatican City State)',
          'HN': 'Honduras',
          'HK': 'Hong Kong',
          'HU': 'Hungary',
          'IS': 'Iceland',
          'IN': 'India',
          'ID': 'Indonesia',
          'IR': 'Iran, Islamic Republic of',
          'IQ': 'Iraq',
          'IE': 'Ireland',
          'IM': 'Isle of Man',
          'IL': 'Israel',
          'IT': 'Italy',
          'JM': 'Jamaica',
          'JP': 'Japan',
          'JE': 'Jersey',
          'JO': 'Jordan',
          'KZ': 'Kazakhstan',
          'KE': 'Kenya',
          'KI': 'Kiribati',
          'KP': 'Korea, Democratic People\'s Republic of',
          'KR': 'Korea, Republic of',
          'KW': 'Kuwait',
          'KG': 'Kyrgyzstan',
          'LA': 'Lao People\'s Democratic Republic',
          'LV': 'Latvia',
          'LB': 'Lebanon',
          'LS': 'Lesotho',
          'LR': 'Liberia',
          'LY': 'Libya',
          'LI': 'Liechtenstein',
          'LT': 'Lithuania',
          'LU': 'Luxembourg',
          'MO': 'Macao',
          'MK': 'Macedonia, the Former Yugoslav Republic of',
          'MG': 'Madagascar',
          'MW': 'Malawi',
          'MY': 'Malaysia',
          'MV': 'Maldives',
          'ML': 'Mali',
          'MT': 'Malta',
          'MH': 'Marshall Islands',
          'MQ': 'Martinique',
          'MR': 'Mauritania',
          'MU': 'Mauritius',
          'YT': 'Mayotte',
          'MX': 'Mexico',
          'FM': 'Micronesia, Federated States of',
          'MD': 'Moldova, Republic of',
          'MC': 'Monaco',
          'MN': 'Mongolia',
          'ME': 'Montenegro',
          'MS': 'Montserrat',
          'MA': 'Morocco',
          'MZ': 'Mozambique',
          'MM': 'Myanmar',
          'NA': 'Namibia',
          'NR': 'Nauru',
          'NP': 'Nepal',
          'NL': 'Netherlands',
          'NC': 'New Caledonia',
          'NZ': 'New Zealand',
          'NI': 'Nicaragua',
          'NE': 'Niger',
          'NG': 'Nigeria',
          'NU': 'Niue',
          'NF': 'Norfolk Island',
          'MP': 'Northern Mariana Islands',
          'NO': 'Norway',
          'OM': 'Oman',
          'PK': 'Pakistan',
          'PW': 'Palau',
          'PS': 'Palestine, State of',
          'PA': 'Panama',
          'PG': 'Papua New Guinea',
          'PY': 'Paraguay',
          'PE': 'Peru',
          'PH': 'Philippines',
          'PN': 'Pitcairn',
          'PL': 'Poland',
          'PT': 'Portugal',
          'PR': 'Puerto Rico',
          'QA': 'Qatar',
          'RE': 'Réunion',
          'RO': 'Romania',
          'RU': 'Russian Federation',
          'RW': 'Rwanda',
          'BL': 'Saint Barthélemy',
          'SH': 'Saint Helena, Ascension and Tristan da Cunha',
          'KN': 'Saint Kitts and Nevis',
          'LC': 'Saint Lucia',
          'MF': 'Saint Martin (French part)',
          'PM': 'Saint Pierre and Miquelon',
          'VC': 'Saint Vincent and the Grenadines',
          'WS': 'Samoa',
          'SM': 'San Marino',
          'ST': 'Sao Tome and Principe',
          'SA': 'Saudi Arabia',
          'SN': 'Senegal',
          'RS': 'Serbia',
          'SC': 'Seychelles',
          'SL': 'Sierra Leone',
          'SG': 'Singapore',
          'SX': 'Sint Maarten (Dutch part)',
          'SK': 'Slovakia',
          'SI': 'Slovenia',
          'SB': 'Solomon Islands',
          'SO': 'Somalia',
          'ZA': 'South Africa',
          'GS': 'South Georgia and the South Sandwich Islands',
          'SS': 'South Sudan',
          'ES': 'Spain',
          'LK': 'Sri Lanka',
          'SD': 'Sudan',
          'SR': 'Suriname',
          'SJ': 'Svalbard and Jan Mayen',
          'SZ': 'Swaziland',
          'SE': 'Sweden',
          'CH': 'Switzerland',
          'SY': 'Syrian Arab Republic',
          'TW': 'Taiwan, Province of China',
          'TJ': 'Tajikistan',
          'TZ': 'Tanzania, United Republic of',
          'TH': 'Thailand',
          'TL': 'Timor-Leste',
          'TG': 'Togo',
          'TK': 'Tokelau',
          'TO': 'Tonga',
          'TT': 'Trinidad and Tobago',
          'TN': 'Tunisia',
          'TR': 'Turkey',
          'TM': 'Turkmenistan',
          'TC': 'Turks and Caicos Islands',
          'TV': 'Tuvalu',
          'UG': 'Uganda',
          'UA': 'Ukraine',
          'AE': 'United Arab Emirates',
          'GB': 'United Kingdom',
          'US': 'United States',
          'UM': 'United States Minor Outlying Islands',
          'UY': 'Uruguay',
          'UZ': 'Uzbekistan',
          'VU': 'Vanuatu',
          'VE': 'Venezuela, Bolivarian Republic of',
          'VN': 'Viet Nam',
          'VG': 'Virgin Islands, British',
          'VI': 'Virgin Islands, U.S.',
          'WF': 'Wallis and Futuna',
          'EH': 'Western Sahara',
          'YE': 'Yemen',
          'ZM': 'Zambia',
          'ZW': 'Zimbabwe'
        },
        currencies: [
          {
            'symbol': '$',
            'name': 'US Dollar',
            'symbol_native': '$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'USD',
            'name_plural': 'US dollars'
          },
          {
            'symbol': 'CA$',
            'name': 'Canadian Dollar',
            'symbol_native': '$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'CAD',
            'name_plural': 'Canadian dollars'
          },
          {
            'symbol': '€',
            'name': 'Euro',
            'symbol_native': '€',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'EUR',
            'name_plural': 'euros'
          },
          {
            'symbol': 'AED',
            'name': 'United Arab Emirates Dirham',
            'symbol_native': 'د.إ.‏',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'AED',
            'name_plural': 'UAE dirhams'
          },
          {
            'symbol': 'Af',
            'name': 'Afghan Afghani',
            'symbol_native': '؋',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'AFN',
            'name_plural': 'Afghan Afghanis'
          },
          {
            'symbol': 'ALL',
            'name': 'Albanian Lek',
            'symbol_native': 'Lek',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'ALL',
            'name_plural': 'Albanian lekë'
          },
          {
            'symbol': 'AMD',
            'name': 'Armenian Dram',
            'symbol_native': 'դր.',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'AMD',
            'name_plural': 'Armenian drams'
          },
          {
            'symbol': 'AR$',
            'name': 'Argentine Peso',
            'symbol_native': '$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'ARS',
            'name_plural': 'Argentine pesos'
          },
          {
            'symbol': 'AU$',
            'name': 'Australian Dollar',
            'symbol_native': '$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'AUD',
            'name_plural': 'Australian dollars'
          },
          {
            'symbol': 'man.',
            'name': 'Azerbaijani Manat',
            'symbol_native': 'ман.',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'AZN',
            'name_plural': 'Azerbaijani manats'
          },
          {
            'symbol': 'KM',
            'name': 'Bosnia-Herzegovina Convertible Mark',
            'symbol_native': 'KM',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'BAM',
            'name_plural': 'Bosnia-Herzegovina convertible marks'
          },
          {
            'symbol': 'Tk',
            'name': 'Bangladeshi Taka',
            'symbol_native': '৳',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'BDT',
            'name_plural': 'Bangladeshi takas'
          },
          {
            'symbol': 'BGN',
            'name': 'Bulgarian Lev',
            'symbol_native': 'лв.',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'BGN',
            'name_plural': 'Bulgarian leva'
          },
          {
            'symbol': 'BD',
            'name': 'Bahraini Dinar',
            'symbol_native': 'د.ب.‏',
            'decimal_digits': 3,
            'rounding': 0,
            'code': 'BHD',
            'name_plural': 'Bahraini dinars'
          },
          {
            'symbol': 'FBu',
            'name': 'Burundian Franc',
            'symbol_native': 'FBu',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'BIF',
            'name_plural': 'Burundian francs'
          },
          {
            'symbol': 'BN$',
            'name': 'Brunei Dollar',
            'symbol_native': '$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'BND',
            'name_plural': 'Brunei dollars'
          },
          {
            'symbol': 'Bs',
            'name': 'Bolivian Boliviano',
            'symbol_native': 'Bs',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'BOB',
            'name_plural': 'Bolivian bolivianos'
          },
          {
            'symbol': 'R$',
            'name': 'Brazilian Real',
            'symbol_native': 'R$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'BRL',
            'name_plural': 'Brazilian reals'
          },
          {
            'symbol': 'BWP',
            'name': 'Botswanan Pula',
            'symbol_native': 'P',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'BWP',
            'name_plural': 'Botswanan pulas'
          },
          {
            'symbol': 'BYR',
            'name': 'Belarusian Ruble',
            'symbol_native': 'BYR',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'BYR',
            'name_plural': 'Belarusian rubles'
          },
          {
            'symbol': 'BZ$',
            'name': 'Belize Dollar',
            'symbol_native': '$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'BZD',
            'name_plural': 'Belize dollars'
          },
          {
            'symbol': 'CDF',
            'name': 'Congolese Franc',
            'symbol_native': 'FrCD',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'CDF',
            'name_plural': 'Congolese francs'
          },
          {
            'symbol': 'CHF',
            'name': 'Swiss Franc',
            'symbol_native': 'CHF',
            'decimal_digits': 2,
            'rounding': 0.05,
            'code': 'CHF',
            'name_plural': 'Swiss francs'
          },
          {
            'symbol': 'CL$',
            'name': 'Chilean Peso',
            'symbol_native': '$',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'CLP',
            'name_plural': 'Chilean pesos'
          },
          {
            'symbol': 'CN¥',
            'name': 'Chinese Yuan',
            'symbol_native': 'CN¥',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'CNY',
            'name_plural': 'Chinese yuan'
          },
          {
            'symbol': 'CO$',
            'name': 'Colombian Peso',
            'symbol_native': '$',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'COP',
            'name_plural': 'Colombian pesos'
          },
          {
            'symbol': '₡',
            'name': 'Costa Rican Colón',
            'symbol_native': '₡',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'CRC',
            'name_plural': 'Costa Rican colóns'
          },
          {
            'symbol': 'CV$',
            'name': 'Cape Verdean Escudo',
            'symbol_native': 'CV$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'CVE',
            'name_plural': 'Cape Verdean escudos'
          },
          {
            'symbol': 'Kč',
            'name': 'Czech Republic Koruna',
            'symbol_native': 'Kč',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'CZK',
            'name_plural': 'Czech Republic korunas'
          },
          {
            'symbol': 'Fdj',
            'name': 'Djiboutian Franc',
            'symbol_native': 'Fdj',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'DJF',
            'name_plural': 'Djiboutian francs'
          },
          {
            'symbol': 'Dkr',
            'name': 'Danish Krone',
            'symbol_native': 'kr',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'DKK',
            'name_plural': 'Danish kroner'
          },
          {
            'symbol': 'RD$',
            'name': 'Dominican Peso',
            'symbol_native': 'RD$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'DOP',
            'name_plural': 'Dominican pesos'
          },
          {
            'symbol': 'DA',
            'name': 'Algerian Dinar',
            'symbol_native': 'د.ج.‏',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'DZD',
            'name_plural': 'Algerian dinars'
          },
          {
            'symbol': 'Ekr',
            'name': 'Estonian Kroon',
            'symbol_native': 'kr',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'EEK',
            'name_plural': 'Estonian kroons'
          },
          {
            'symbol': 'EGP',
            'name': 'Egyptian Pound',
            'symbol_native': 'ج.م.‏',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'EGP',
            'name_plural': 'Egyptian pounds'
          },
          {
            'symbol': 'Nfk',
            'name': 'Eritrean Nakfa',
            'symbol_native': 'Nfk',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'ERN',
            'name_plural': 'Eritrean nakfas'
          },
          {
            'symbol': 'Br',
            'name': 'Ethiopian Birr',
            'symbol_native': 'Br',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'ETB',
            'name_plural': 'Ethiopian birrs'
          },
          {
            'symbol': '£',
            'name': 'British Pound Sterling',
            'symbol_native': '£',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'GBP',
            'name_plural': 'British pounds sterling'
          },
          {
            'symbol': 'GEL',
            'name': 'Georgian Lari',
            'symbol_native': 'GEL',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'GEL',
            'name_plural': 'Georgian laris'
          },
          {
            'symbol': 'GH₵',
            'name': 'Ghanaian Cedi',
            'symbol_native': 'GH₵',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'GHS',
            'name_plural': 'Ghanaian cedis'
          },
          {
            'symbol': 'FG',
            'name': 'Guinean Franc',
            'symbol_native': 'FG',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'GNF',
            'name_plural': 'Guinean francs'
          },
          {
            'symbol': 'GTQ',
            'name': 'Guatemalan Quetzal',
            'symbol_native': 'Q',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'GTQ',
            'name_plural': 'Guatemalan quetzals'
          },
          {
            'symbol': 'HK$',
            'name': 'Hong Kong Dollar',
            'symbol_native': '$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'HKD',
            'name_plural': 'Hong Kong dollars'
          },
          {
            'symbol': 'HNL',
            'name': 'Honduran Lempira',
            'symbol_native': 'L',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'HNL',
            'name_plural': 'Honduran lempiras'
          },
          {
            'symbol': 'kn',
            'name': 'Croatian Kuna',
            'symbol_native': 'kn',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'HRK',
            'name_plural': 'Croatian kunas'
          },
          {
            'symbol': 'Ft',
            'name': 'Hungarian Forint',
            'symbol_native': 'Ft',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'HUF',
            'name_plural': 'Hungarian forints'
          },
          {
            'symbol': 'Rp',
            'name': 'Indonesian Rupiah',
            'symbol_native': 'Rp',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'IDR',
            'name_plural': 'Indonesian rupiahs'
          },
          {
            'symbol': '₪',
            'name': 'Israeli New Sheqel',
            'symbol_native': '₪',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'ILS',
            'name_plural': 'Israeli new sheqels'
          },
          {
            'symbol': 'Rs',
            'name': 'Indian Rupee',
            'symbol_native': 'টকা',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'INR',
            'name_plural': 'Indian rupees'
          },
          {
            'symbol': 'IQD',
            'name': 'Iraqi Dinar',
            'symbol_native': 'د.ع.‏',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'IQD',
            'name_plural': 'Iraqi dinars'
          },
          {
            'symbol': 'IRR',
            'name': 'Iranian Rial',
            'symbol_native': '﷼',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'IRR',
            'name_plural': 'Iranian rials'
          },
          {
            'symbol': 'Ikr',
            'name': 'Icelandic Króna',
            'symbol_native': 'kr',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'ISK',
            'name_plural': 'Icelandic krónur'
          },
          {
            'symbol': 'J$',
            'name': 'Jamaican Dollar',
            'symbol_native': '$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'JMD',
            'name_plural': 'Jamaican dollars'
          },
          {
            'symbol': 'JD',
            'name': 'Jordanian Dinar',
            'symbol_native': 'د.أ.‏',
            'decimal_digits': 3,
            'rounding': 0,
            'code': 'JOD',
            'name_plural': 'Jordanian dinars'
          },
          {
            'symbol': '¥',
            'name': 'Japanese Yen',
            'symbol_native': '￥',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'JPY',
            'name_plural': 'Japanese yen'
          },
          {
            'symbol': 'Ksh',
            'name': 'Kenyan Shilling',
            'symbol_native': 'Ksh',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'KES',
            'name_plural': 'Kenyan shillings'
          },
          {
            'symbol': 'KHR',
            'name': 'Cambodian Riel',
            'symbol_native': '៛',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'KHR',
            'name_plural': 'Cambodian riels'
          },
          {
            'symbol': 'CF',
            'name': 'Comorian Franc',
            'symbol_native': 'FC',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'KMF',
            'name_plural': 'Comorian francs'
          },
          {
            'symbol': '₩',
            'name': 'South Korean Won',
            'symbol_native': '₩',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'KRW',
            'name_plural': 'South Korean won'
          },
          {
            'symbol': 'KD',
            'name': 'Kuwaiti Dinar',
            'symbol_native': 'د.ك.‏',
            'decimal_digits': 3,
            'rounding': 0,
            'code': 'KWD',
            'name_plural': 'Kuwaiti dinars'
          },
          {
            'symbol': 'KZT',
            'name': 'Kazakhstani Tenge',
            'symbol_native': 'тңг.',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'KZT',
            'name_plural': 'Kazakhstani tenges'
          },
          {
            'symbol': 'LB£',
            'name': 'Lebanese Pound',
            'symbol_native': 'ل.ل.‏',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'LBP',
            'name_plural': 'Lebanese pounds'
          },
          {
            'symbol': 'SLRs',
            'name': 'Sri Lankan Rupee',
            'symbol_native': 'SL Re',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'LKR',
            'name_plural': 'Sri Lankan rupees'
          },
          {
            'symbol': 'Lt',
            'name': 'Lithuanian Litas',
            'symbol_native': 'Lt',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'LTL',
            'name_plural': 'Lithuanian litai'
          },
          {
            'symbol': 'Ls',
            'name': 'Latvian Lats',
            'symbol_native': 'Ls',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'LVL',
            'name_plural': 'Latvian lati'
          },
          {
            'symbol': 'LD',
            'name': 'Libyan Dinar',
            'symbol_native': 'د.ل.‏',
            'decimal_digits': 3,
            'rounding': 0,
            'code': 'LYD',
            'name_plural': 'Libyan dinars'
          },
          {
            'symbol': 'MAD',
            'name': 'Moroccan Dirham',
            'symbol_native': 'د.م.‏',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'MAD',
            'name_plural': 'Moroccan dirhams'
          },
          {
            'symbol': 'MDL',
            'name': 'Moldovan Leu',
            'symbol_native': 'MDL',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'MDL',
            'name_plural': 'Moldovan lei'
          },
          {
            'symbol': 'MGA',
            'name': 'Malagasy Ariary',
            'symbol_native': 'MGA',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'MGA',
            'name_plural': 'Malagasy Ariaries'
          },
          {
            'symbol': 'MKD',
            'name': 'Macedonian Denar',
            'symbol_native': 'MKD',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'MKD',
            'name_plural': 'Macedonian denari'
          },
          {
            'symbol': 'MMK',
            'name': 'Myanma Kyat',
            'symbol_native': 'K',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'MMK',
            'name_plural': 'Myanma kyats'
          },
          {
            'symbol': 'MOP$',
            'name': 'Macanese Pataca',
            'symbol_native': 'MOP$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'MOP',
            'name_plural': 'Macanese patacas'
          },
          {
            'symbol': 'MURs',
            'name': 'Mauritian Rupee',
            'symbol_native': 'MURs',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'MUR',
            'name_plural': 'Mauritian rupees'
          },
          {
            'symbol': 'MX$',
            'name': 'Mexican Peso',
            'symbol_native': '$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'MXN',
            'name_plural': 'Mexican pesos'
          },
          {
            'symbol': 'RM',
            'name': 'Malaysian Ringgit',
            'symbol_native': 'RM',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'MYR',
            'name_plural': 'Malaysian ringgits'
          },
          {
            'symbol': 'MTn',
            'name': 'Mozambican Metical',
            'symbol_native': 'MTn',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'MZN',
            'name_plural': 'Mozambican meticals'
          },
          {
            'symbol': 'N$',
            'name': 'Namibian Dollar',
            'symbol_native': 'N$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'NAD',
            'name_plural': 'Namibian dollars'
          },
          {
            'symbol': '₦',
            'name': 'Nigerian Naira',
            'symbol_native': '₦',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'NGN',
            'name_plural': 'Nigerian nairas'
          },
          {
            'symbol': 'C$',
            'name': 'Nicaraguan Córdoba',
            'symbol_native': 'C$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'NIO',
            'name_plural': 'Nicaraguan córdobas'
          },
          {
            'symbol': 'Nkr',
            'name': 'Norwegian Krone',
            'symbol_native': 'kr',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'NOK',
            'name_plural': 'Norwegian kroner'
          },
          {
            'symbol': 'NPRs',
            'name': 'Nepalese Rupee',
            'symbol_native': 'नेरू',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'NPR',
            'name_plural': 'Nepalese rupees'
          },
          {
            'symbol': 'NZ$',
            'name': 'New Zealand Dollar',
            'symbol_native': '$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'NZD',
            'name_plural': 'New Zealand dollars'
          },
          {
            'symbol': 'OMR',
            'name': 'Omani Rial',
            'symbol_native': 'ر.ع.‏',
            'decimal_digits': 3,
            'rounding': 0,
            'code': 'OMR',
            'name_plural': 'Omani rials'
          },
          {
            'symbol': 'B/.',
            'name': 'Panamanian Balboa',
            'symbol_native': 'B/.',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'PAB',
            'name_plural': 'Panamanian balboas'
          },
          {
            'symbol': 'S/.',
            'name': 'Peruvian Nuevo Sol',
            'symbol_native': 'S/.',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'PEN',
            'name_plural': 'Peruvian nuevos soles'
          },
          {
            'symbol': '₱',
            'name': 'Philippine Peso',
            'symbol_native': '₱',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'PHP',
            'name_plural': 'Philippine pesos'
          },
          {
            'symbol': 'PKRs',
            'name': 'Pakistani Rupee',
            'symbol_native': '₨',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'PKR',
            'name_plural': 'Pakistani rupees'
          },
          {
            'symbol': 'zł',
            'name': 'Polish Zloty',
            'symbol_native': 'zł',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'PLN',
            'name_plural': 'Polish zlotys'
          },
          {
            'symbol': '₲',
            'name': 'Paraguayan Guarani',
            'symbol_native': '₲',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'PYG',
            'name_plural': 'Paraguayan guaranis'
          },
          {
            'symbol': 'QR',
            'name': 'Qatari Rial',
            'symbol_native': 'ر.ق.‏',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'QAR',
            'name_plural': 'Qatari rials'
          },
          {
            'symbol': 'RON',
            'name': 'Romanian Leu',
            'symbol_native': 'RON',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'RON',
            'name_plural': 'Romanian lei'
          },
          {
            'symbol': 'din.',
            'name': 'Serbian Dinar',
            'symbol_native': 'дин.',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'RSD',
            'name_plural': 'Serbian dinars'
          },
          {
            'symbol': 'RUB',
            'name': 'Russian Ruble',
            'symbol_native': 'руб.',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'RUB',
            'name_plural': 'Russian rubles'
          },
          {
            'symbol': 'RWF',
            'name': 'Rwandan Franc',
            'symbol_native': 'FR',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'RWF',
            'name_plural': 'Rwandan francs'
          },
          {
            'symbol': 'SR',
            'name': 'Saudi Riyal',
            'symbol_native': 'ر.س.‏',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'SAR',
            'name_plural': 'Saudi riyals'
          },
          {
            'symbol': 'SDG',
            'name': 'Sudanese Pound',
            'symbol_native': 'SDG',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'SDG',
            'name_plural': 'Sudanese pounds'
          },
          {
            'symbol': 'Skr',
            'name': 'Swedish Krona',
            'symbol_native': 'kr',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'SEK',
            'name_plural': 'Swedish kronor'
          },
          {
            'symbol': 'S$',
            'name': 'Singapore Dollar',
            'symbol_native': '$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'SGD',
            'name_plural': 'Singapore dollars'
          },
          {
            'symbol': 'Ssh',
            'name': 'Somali Shilling',
            'symbol_native': 'Ssh',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'SOS',
            'name_plural': 'Somali shillings'
          },
          {
            'symbol': 'SY£',
            'name': 'Syrian Pound',
            'symbol_native': 'ل.س.‏',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'SYP',
            'name_plural': 'Syrian pounds'
          },
          {
            'symbol': '฿',
            'name': 'Thai Baht',
            'symbol_native': '฿',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'THB',
            'name_plural': 'Thai baht'
          },
          {
            'symbol': 'DT',
            'name': 'Tunisian Dinar',
            'symbol_native': 'د.ت.‏',
            'decimal_digits': 3,
            'rounding': 0,
            'code': 'TND',
            'name_plural': 'Tunisian dinars'
          },
          {
            'symbol': 'T$',
            'name': 'Tongan Paʻanga',
            'symbol_native': 'T$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'TOP',
            'name_plural': 'Tongan paʻanga'
          },
          {
            'symbol': 'TL',
            'name': 'Turkish Lira',
            'symbol_native': 'TL',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'TRY',
            'name_plural': 'Turkish Lira'
          },
          {
            'symbol': 'TT$',
            'name': 'Trinidad and Tobago Dollar',
            'symbol_native': '$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'TTD',
            'name_plural': 'Trinidad and Tobago dollars'
          },
          {
            'symbol': 'NT$',
            'name': 'New Taiwan Dollar',
            'symbol_native': 'NT$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'TWD',
            'name_plural': 'New Taiwan dollars'
          },
          {
            'symbol': 'TSh',
            'name': 'Tanzanian Shilling',
            'symbol_native': 'TSh',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'TZS',
            'name_plural': 'Tanzanian shillings'
          },
          {
            'symbol': '₴',
            'name': 'Ukrainian Hryvnia',
            'symbol_native': '₴',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'UAH',
            'name_plural': 'Ukrainian hryvnias'
          },
          {
            'symbol': 'USh',
            'name': 'Ugandan Shilling',
            'symbol_native': 'USh',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'UGX',
            'name_plural': 'Ugandan shillings'
          },
          {
            'symbol': '$U',
            'name': 'Uruguayan Peso',
            'symbol_native': '$',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'UYU',
            'name_plural': 'Uruguayan pesos'
          },
          {
            'symbol': 'UZS',
            'name': 'Uzbekistan Som',
            'symbol_native': 'UZS',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'UZS',
            'name_plural': 'Uzbekistan som'
          },
          {
            'symbol': 'Bs.F.',
            'name': 'Venezuelan Bolívar',
            'symbol_native': 'Bs.F.',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'VEF',
            'name_plural': 'Venezuelan bolívars'
          },
          {
            'symbol': '₫',
            'name': 'Vietnamese Dong',
            'symbol_native': '₫',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'VND',
            'name_plural': 'Vietnamese dong'
          },
          {
            'symbol': 'FCFA',
            'name': 'CFA Franc BEAC',
            'symbol_native': 'FCFA',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'XAF',
            'name_plural': 'CFA francs BEAC'
          },
          {
            'symbol': 'CFA',
            'name': 'CFA Franc BCEAO',
            'symbol_native': 'CFA',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'XOF',
            'name_plural': 'CFA francs BCEAO'
          },
          {
            'symbol': 'YR',
            'name': 'Yemeni Rial',
            'symbol_native': 'ر.ي.‏',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'YER',
            'name_plural': 'Yemeni rials'
          },
          {
            'symbol': 'R',
            'name': 'South African Rand',
            'symbol_native': 'R',
            'decimal_digits': 2,
            'rounding': 0,
            'code': 'ZAR',
            'name_plural': 'South African rand'
          },
          {
            'symbol': 'ZK',
            'name': 'Zambian Kwacha',
            'symbol_native': 'ZK',
            'decimal_digits': 0,
            'rounding': 0,
            'code': 'ZMK',
            'name_plural': 'Zambian kwachas'
          }
        ],
        order_status: {
          1: 'Pending Payment',
          2: 'Ordered',
          3: 'Sent To POS',
          4: 'POS Fail',
          5: 'Cooking',
          6: 'Delivering',
          7: 'Completed',
          8: 'Cancelled',
          9: 'Completed Manually',
          10: 'Processed',
          11: 'Processed 30 Mins',
          12: 'Processed 45 Mins',
          13: 'Processed 45 NOGUA',
          14: 'Processed 60 Mins',
          22: 'Order Submission Fail',
          25: 'Order Submission Complete',
          27: 'Before Order Submission',
          28: 'Order Cancellation By Payment',
        },
        order_step: {
          1: 'Pending',
          2: 'Accepted',
          3: 'Preparing',
          4: 'Cooking',
          5: 'Driver Tracking',
          6: 'Complete'
        },
        aggregators: {
          'rakuten-deli': 'Rakuten Delivery',
          'demae-can': 'Demae-can',
          'gnavi-deli': 'Gurunavi',
          "uber-eats": "Uber Eats"
        },
        config_options: {
          outlet: {}
        },
        item: {
          uuid: '',
          name: '',
          contact_name: '',
          email: '',
          phone: '',
          config: '',
          status: 1,
          country: '',
          main_config: {
            backend: {
              apple: {
                app_id: '',
                key_id: '',
                team_id: '',
                app_secret: ''
              },
              fb: {
                app_id: '',
                app_secret: ''
              },
              api_key: ''
            },
            social: {
              fb: {
                app_id: ''
              },
              gg: {
                web: '',
                android: '',
                ios: ''
              },
            },
            language: [],
            main_language: '',
            tiers: [],
            tax: '',
            point_rate: 30,
            currency: 'yen',
            google_api_key: '',
            email_flag: 1,
            sms_flag: 1,
            tax_flag: 1,
            discount_apply_flag: 1,
            order_status_mappings: {
              1: 1, // pendingPayment
              2: 2, // ordered
              3: 2, // sentToPOS
              4: 5, // posFail
              5: 4, // cooking
              6: 5, // delivering
              7: 6, // completed
              8: 6, // cancelled
              9: 6, // completedManually
              10: 2, // processed
              11: 2, // processed30Mins
              12: 2, // processed45Mins
              13: 2, // processed45NOGUA
              14: 2, // processed60Mins
              22: 1,//'Order Submission Fail',
              25: 1,//'Order Submission Complete',
              27: 1,//'Before Order Submission',
              28: 1,//'Order Cancellation By Payment',
            },
            total_discount: -1,
            tax_total: -1,
            total: -1,
            money_for_point: 1,
            min_cart_include_delivery_fee: 1,
            date_format: 'dd-mm-yyyy',
            ios_maintenance : 0,
            android_maintenance: 0,
            web_maintenance: 0,
            fcds_app: 1,
            calendar_notification: 1,
            ios_min_version: 12,
            android_min_version: 67,
            auto_coupon: 0,
            half_half_full_price: 0,
            join_membership: 0,
            christmas_theme: 0
          },
          gms_config: {
            base: {
              logo: '',
              aggregators: {
                'rakuten-deli': 1,
                'demae-can': 1,
                'gnavi-deli': 1,
                'uber-eats': 1
              },
              calendar_notification: 1
            },
            outlet: {},
            menu: {},
            combo: {},
            order: {},
            customer: {},
            report: {},
            category: {},
            banner: {},
            menu_half_half: {}
          }
        },
        manual_config: [],
        isUserBtnDisabled: true
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      item: {
        name: {
          required
        },
        contact_name: {
          required
        },
        phone: {
          required
        },
        email: {
          required,
          email
        },
        config: {
          required
        },
        country: {
          required
        },
        main_config: {
          language: {
            required
          },
          google_api_key: {
            required
          },
          tiers: {
            required
          }
        }
      }
    },
    methods: {
      addTier () {
        this.tier.push({
          text: '',
          value: this.tier.length + 1
        })
      },
      removeTier () {
        if (this.tier.length <= 1) {
          return
        }
        let tierTemp = []
        for (let i = 0; i < this.tier.length - 1; i++) {
          tierTemp.push(this.tier[i])
        }
        this.tier = tierTemp
      },
      checkSubmit: function () {
        return vm.$v.item.$invalid
      },
      isJSON: function (str) {
        try {
          JSON.parse(str)
        } catch (e) {
          return false
        }
        return true
      },
      saveClient () {
        // call an API to save client information
        // check create or update
        this.item.main_config.backend.fb.app_id = this.item.main_config.social.fb.app_id
        this.item.main_config.tiers = {}
        for (let i in this.tier) {
          this.item.main_config.tiers[this.tier[i].value] = this.tier[i].text
        }
        this.item.gms_config.currency_info = this.selected_currency
        this.item.main_config.language = []
        for (let i in this.selected_languages) {
          this.item.main_config.language.push(this.selected_languages[i].value)
        }
        this.item.main_config.currency = this.selected_currency.code

        for (let i in this.item.main_config.order_status_mappings) {
          this.item.main_config.order_status_mappings[i] = parseInt(this.item.main_config.order_status_mappings[i])
        }

        for (let i in this.item.gms_config.base.aggregators) {
          this.item.gms_config.base.aggregators[i] = parseInt(this.item.gms_config.base.aggregators[i])
        }
        this.item.gms_config.base.calendar_notification = parseInt(this.item.main_config.calendar_notification)

        this.item.manual_config = {}
        for (let i in this.manual_config) {
          this.item.manual_config[this.manual_config[i].key] = this.manual_config[i].value
        }

        if (vm.uuid == 'create' || vm.uuid == undefined) {
          vm.axios.tenant.createClient(this.item, function (response) {
            vm.$router.push({name: 'client_list'})
          })
        } else { // update client
          vm.axios.tenant.updateClient(this.item, function (response) {
            vm.$router.push({name: 'client_list'})
          }, error => {
            console.log('error', error)
          })
        }
      },
      createManualConfig() {
        this.manual_config.push({
          key: '',
          value: ''
        })
      },
      deleteManualConfig (index) {
        this.manual_config.splice(index, 1)
      },
    },
    created: function () {
      vm = this
      for (let i in this.currencies) {
        this.test.push(this.currencies[i])
      }

      let user = this.$auth.user()
      let id = vm._.get(user, 'user_info.user.id', 0)

      //Verify role super admin
      if(1 == id) {
        vm.isUserBtnDisabled = false;
      } else {
        vm.axios.user.getUserRoles(respone => {
          if (respone.status === 200) {
            let roleDataList = vm._.get(respone, 'data.data.roles', [])
            let len = roleDataList.length

            for (var i = 0; i < len; i++) {
              //Verify role org-admin
              if(roleDataList[i] && 'org-admin' === roleDataList[i]) {
                vm.isUserBtnDisabled = false
                break
              }
            }
          }
        }, error => {
          console.log('error', error)
        })
      }
    },
    mounted: function () {
      if (vm.uuid == 'create' || vm.uuid == undefined) {
      } else {
        let vm = this
        vm.axios.tenant.getClientDetail(vm.uuid, function (response) {
          let item = JSON.parse(JSON.stringify(response.data.data.item))

          if (typeof item.main_config.social === 'undefined' || item.main_config.social.fb === null || item.main_config.social.gg === null) {
            item.main_config = {
              backend: {
                fb: {
                  app_id: '',
                  app_secret: ''
                },
              },
              social: {
                fb: {
                  app_id: ''
                },
                gg: {
                  web: '',
                  android: '',
                  ios: ''
                }
              }
            }
          }

          if (typeof item.main_config.social.fb.app_id === 'undefined' || typeof item.main_config.social.fb.app_secret === 'undefined') {
            item.main_config.backend.fb = {
              app_id: '',
              app_secret: ''
            }
            item.main_config.social.fb = {
              app_id: ''
            }
          }
          if (typeof item.main_config.backend == 'undefined') {
            item.main_config.backend = {
              fb: {
                app_id: '',
                app_secret: ''
              },
              apple: {
                app_id: '',
                key_id: '',
                team_id: '',
                app_secret: ''
              }
            }
          }

          if (typeof item.main_config.social.fb.app_secret !== 'undefined' && (item.main_config.backend.fb.app_secret == null || item.main_config.backend.fb.app_secret == '')) {
            item.main_config.backend.fb.app_secret = item.main_config.social.fb.app_secret
          }
          if (typeof item.main_config.social.gg.web === 'undefined' || typeof item.main_config.social.gg.android === 'undefined' || typeof item.main_config.social.gg.ios === 'undefined') {
            item.main_config.social.gg = {
              web: '',
              android: '',
              ios: ''
            }
          }
          if (!item.main_config.backend.hasOwnProperty('apple') || typeof item.main_config.backend.apple === 'undefined' || item.main_config.backend.apple === null) {
            item.main_config.backend.apple = {
              app_id: '',
              key_id: '',
              team_id: '',
              app_secret: ''
            }
          }
          for (let i in item.manual_config) {
            vm.manual_config.push({
              key: i,
              value: item.manual_config[i]
            })
          }

          vm.selected_languages = []
          for (let i in item.main_config.language) {
            for (let j in vm.languages) {
              if (item.main_config.language[i] == vm.languages[j].value) {
                vm.selected_languages.push(vm.languages[j])
              }
            }
          }
          vm.selected_currency = {}
          for (let i in vm.currencies) {
            if (item.main_config.currency == vm.currencies[i].code) {
              vm.selected_currency = vm.currencies[i]
              break
            }
          }
          vm.tier = []

          let tiers = Object.values(item.main_config.tiers)
          if(tiers.length > 0) {
            for (let i in tiers) {
              vm.tier.push({text:tiers[i],value: parseInt(i) + 1})
            }
          }else{
            if (vm.tier.length <= 0) {
              vm.tier = [{
                text: '',
                value: 1
              }]
            }
          }

          for (let i in vm.item) {
            if (item[i] == null) {
              item[i] = vm.item[i]
            }
          }

          if (typeof item.gms_config.base === 'undefined') {
            item.gms_config.base = {
              logo: ''
            }
          }

          for (let i in vm.item.main_config.order_status_mappings) {
            if (item.main_config.order_status_mappings != null && item.main_config.order_status_mappings[i] != null) {
              vm.item.main_config.order_status_mappings[i] = item.main_config.order_status_mappings[i]
            }
            if (item.main_config.order_status_mappings == null) {
              item.main_config.order_status_mappings = {}
            }
            item.main_config.order_status_mappings[i] = parseInt(vm.item.main_config.order_status_mappings[i])
          }

          for (let i in vm.item.gms_config.base.aggregators) {
            if (item.gms_config.base.aggregators != null && item.gms_config.base.aggregators[i] != null) {
              vm.item.gms_config.base.aggregators[i] = item.gms_config.base.aggregators[i]
            }
            if (item.gms_config.base.aggregators == null) {
              item.gms_config.base.aggregators = {}
            }
            item.gms_config.base.aggregators[i] = parseInt(vm.item.gms_config.base.aggregators[i])
          }
          item.gms_config.base.calendar_notification = parseInt(vm.item.main_config.calendar_notification)
          vm.item = item
          vm.item.main_config.social.fb.app_secret = ''
          vm.item.main_config.backend.fb.app_id = vm.item.main_config.social.fb.app_id
        })
      }
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .client-form div.header,
  .client-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }
  .client-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .client-form .card-footer .btn-save{
    float: right;
    margin-right: 22px;
  }
  .input-group-text .custom-checkbox {
    margin-right: 0px;
    padding-left: 1.0rem;
  }
  .currency-info {
    min-height: 40px;
    border-radius: 4px;
    border: 1px solid #b3b3b3;
    padding: 10px 10px 0px 10px;
  }
  .table td {
    padding: 5px 0.75rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/client/Form.vue